import { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Row, Form, Col, Button } from "react-bootstrap";
import SatAPI from "../../_services/sat";
import toastService from "../../_services/toastService";

const api = SatAPI();

function EditModalECTS({ data = {}, hideModal }) {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [min, setMin] = useState(data.min || 0);
  const [max, setMax] = useState(data.max || 0);
  const [hoursPerGrade, setHoursPerGrade] = useState(data.hoursPerGrade || 0);

  const onFormSubmit = async e => {
    e.preventDefault();
    try {
      if (data.ID) {
        await api.updateECTSLoadParameter(data.ID, {
          min,
          max,
          hoursPerGrade,
        });
      } else {
        await api.createECTSLoadParameter({ min, max, hoursPerGrade });
      }

      //api.createSnapshot();
      toastService.send({ title: "Success", message: "Studiepunten belasting is opgeslagen" });
      hideModal();
    } catch (error) {
      toastService.send({ title: "An error occured", message: error });
    }
  };
  return (
    <Modal
      show
      onHide={() => {
        hideModal();
      }}
      backdrop="static"
      keyboard={false}
      centered
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Studiepunten belasting {data.ID ? "bewerken" : "aanmaken"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <Form onSubmit={onFormSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Minimale STP</Form.Label>
                <Form.Control type="number" required onChange={e => setMin(parseInt(e.target.value, 10))} value={min} min={0} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Maximale STP</Form.Label>
                <Form.Control type="number" required onChange={e => setMax(parseInt(e.target.value, 10))} value={max} min={0} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Uren</Form.Label>
                <Form.Control type="number" required onChange={e => setHoursPerGrade(parseInt(e.target.value, 10))} value={hoursPerGrade} />
              </Form.Group>

              <Button variant="primary" type="submit" disabled={snapshot}>
                {data.ID ? (
                  <span>
                    <i className="far fa-edit" />&nbsp;Bewerk
                  </span>
                ) : (
                  <span>
                    <i className="far fa-plus" />&nbsp;Aanmaken{" "}
                  </span>
                )}
              </Button>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default EditModalECTS;
